import { dev } from '$app/environment'
import { PUBLIC_ENV, PUBLIC_SENTRY_DSN_FRONTEND } from '$env/static/public'
import * as Sentry from '@sentry/sveltekit'
import { handleErrorWithSentry, replayIntegration } from '@sentry/sveltekit'

// Get frontend DSN from environment
const SENTRY_DSN = PUBLIC_SENTRY_DSN_FRONTEND
const SENTRY_ENV = PUBLIC_ENV || 'development'

// Initialize Sentry when DSN is configured
if (SENTRY_DSN) {
	console.log('🔍 Initializing Sentry (Frontend):', {
		dsn: SENTRY_DSN.substring(0, 50) + '...',
		env: SENTRY_ENV,
		dev
	})

	Sentry.init({
		dsn: SENTRY_DSN,
		environment: SENTRY_ENV,

		// Performance Monitoring
		tracesSampleRate: 1.0, // 100% in free tier - adjust to 0.1 (10%) after testing

		// Session Replay - captures video-like replays of user sessions
		replaysSessionSampleRate: 0.1, // 10% of normal sessions
		replaysOnErrorSampleRate: 1.0, // 100% of sessions with errors

		integrations: [
			replayIntegration({
				maskAllText: false, // Set to true if you want to mask user text for privacy
				blockAllMedia: false
			})
		],

		// Set release version for tracking
		release: `chiron-mobile@${__APP_VERSION__}`,

		// Ignore common, non-critical errors
		ignoreErrors: [
			'Non-Error promise rejection captured',
			'ResizeObserver loop limit exceeded',
			'ResizeObserver loop completed with undelivered notifications',
			'cancelled',
			'Network request failed'
			// Add more patterns as needed
		],

		// Filter events before sending
		beforeSend(event, hint) {
			console.log('📤 Sentry sending event:', event.event_id, event.exception?.values?.[0]?.value)

			// Don't send errors from browser extensions
			if (
				event.exception?.values?.[0]?.stacktrace?.frames?.some((frame) =>
					frame.filename?.includes('extension://')
				)
			) {
				return null
			}

			return event
		}
	})
}

// SvelteKit error handler integration
export const handleError = handleErrorWithSentry()
